import { createStart, createMiddleware } from "@tanstack/react-start";
import { getTrafficSource } from "@/lib/traffic-source";
import { phSaveFailed } from "@/lib/posthog";

/**
 * Attaches the visitor's first-touch acquisition source (Google, Bing,
 * Facebook, an ad click, direct...) as request headers on every server
 * function call, so every form webhook reports where the customer actually
 * came from rather than just the page the form sat on.
 */
const attachTrafficSource = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    let headers: Record<string, string> = {};
    try {
      const t = getTrafficSource();
      headers = {
        "x-crs-source": encodeURIComponent(t.source ?? ""),
        "x-crs-medium": encodeURIComponent(t.medium ?? ""),
        "x-crs-campaign": encodeURIComponent(t.campaign ?? ""),
        "x-crs-term": encodeURIComponent(t.term ?? ""),
        "x-crs-content": encodeURIComponent(t.content ?? ""),
        "x-crs-referrer": encodeURIComponent(t.referrer ?? ""),
        "x-crs-landing": encodeURIComponent(t.landingPage ?? ""),
      };

    } catch {
      /* never block a submission on tracking */
    }
    try {
      return await next({ headers });
    } catch (error) {
      phSaveFailed("server_function_call", error);
      throw error;
    }
  },
);

export const startInstance = createStart(() => ({
  functionMiddleware: [attachTrafficSource],
}));
